import { Layout } from "antd";

import { PropsWithChildren, useEffect } from "react";
import { scrollToTop } from "../plugins/utils";
import { FooterComponent, HeaderComponent } from "./components";
import styles from "./style.module.scss";

type DefaultLayoutType = PropsWithChildren & {
  navType: any;
};

const DefaultLayout: React.FC<DefaultLayoutType> = ({ navType, children }) => {
  const pathname = window.location.pathname;

  useEffect(() => {
    scrollToTop("main-layout");
  }, [pathname]);

  return (
    <Layout className={styles.mainLayout} id="main-layout">
      <div id="copy-group" />
      {navType.hideHeader === true ? null : <HeaderComponent />}
      <div className={styles.contentContainer} id="containerElement">
        {children}
      </div>
      {navType.hideFooter === true ? null : <FooterComponent />}
    </Layout>
  );
};

export default DefaultLayout;
